import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import analytics_45global from "/app/middleware/analytics.global.ts";
import auth_45global from "/app/middleware/auth.global.ts";
import exit_45intent_45global from "/app/middleware/exitIntent.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  analytics_45global,
  auth_45global,
  exit_45intent_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}